<template>
  <div
    class="table__header"
    :style="{width: props.tableWidth + 'px'}"
  >
    <HeaderCell
      v-for="(cell, index) in props.columnList"
      :key="cell.name"
      class="table__cell"
      :class="cell.name"
      :cell="cell"
      :index="index"
      :column-list="props.columnList"
      :current-sorting-column="currentSortingColumn"
      :current-sorting-order="currentSortingOrder"
      @update-column-width="args => emit('update-column-list', args)"
      @change-sorting-column="val => emit('change-sorting-column', val)"
      @active-cells-in-col="args => emit('activeCellsInCol', args)"
    >
      <template
        v-if="index === 0"
        #selector
      >
        <Checkbox
          class="checkbox-url"
          name="checkedAllRows"
          :model-value="checkedAllRows"
          @update:model-value="$emit('update:checkedAllRows', $event)"
          @click.stop
        />
      </template>

      <template
        v-if="cell.name !== 'isEnabled'"
        #title
      >
        {{ cell.title }}
      </template>
    </HeaderCell>
  </div>
</template>

<script setup>
import { defineProps} from "vue";
import HeaderCell from "@/components/table/HeaderCell.vue";

const props = defineProps({
  tableWidth: {
    type: Number,
    required: true
  },
  checkedAllRows: {
    type: Boolean,
    required: true
  },
  currentSortingColumn: {
    type: [String, null],
    required: true,
    default: () => null
  },
  currentSortingOrder: {
    type: String,
    required: true,
    default: () => "asc"
  },
  columnList: {
    type: Array,
    required: true
  },
});

const emit = defineEmits(["change-sorting-column", "update-filter", "activeCellsInCol", "update:checkedAllRows", "update-column-list"]);
</script>

<style lang="scss" scoped>
.table {
  &__header {
    display: flex;
  }
  &__cell {
    background: var(--outline-grey2);
    display: flex;
    align-items: center;
    padding: 15px 25px;
    gap: 5px;
    position: relative;
    white-space: nowrap;
    cursor: pointer;

    //&:first-child {
    //  padding-left: 50px;
    //}

    &:not(:last-child) {
      border-right: 1px solid var(--button-secondary-hower);
    }
  }
}

.checkbox-url {
  margin-right: 8px;
  margin-top: 6px;
}

</style>